import { MINI_HOST_APP_FLAGS } from './miniHostAppFlags';
import type { MiniHostAppFlag, MiniHostAppFeature } from './miniHostAppFlags';

export function getFlagDefaults(flagName: MiniHostAppFeature): MiniHostAppFlag {
    return MINI_HOST_APP_FLAGS[flagName];
}
